
import Theme from "@/module/theme/theme"
import Utils from "@/module/utils/utils"

export default {
    data() {
        return {
            form_value: {},
            name: null,
            isDisplay: true
        }
    },

    props: {
        data: Object,
        config: Object,
        entity: String,
        isList: {
            type: Boolean,
            default: false,
        },
        index: Number,
        value: {
            type: Object,
            default: new Object(),
        },
    },

    watch: {
        value: function (value: any) {
            this.form_value = value
        },
    },

    created() {
        const form_value = (this.form_value = this.value || {})
        this.initial_value = Utils.copy(form_value)

        this.name = this.entity ? `${this.entity}[${this.index}].${this.data.name}` : this.data.name
    },

    mounted() {
        Theme.processPage(this.$el)
        // 监听页面大小变化
        window.addEventListener("resize", this.onResize)
        // 初始化
        this.$nextTick(() => this.onResize())
    },

    beforeUnmount() {
        // 移除监听
        window.removeEventListener("resize", this.onResize)
    },

    methods: {
        onResize() {
            if (!this.$refs.elem) return
            // 获取父级元素的宽度
            const width = this.$refs.elem.parentElement.offsetWidth

            if (width > 1200) {
                this.$refs.elem.style.width = "33.33%"
            } else if (width > 800) {
                this.$refs.elem.style.width = "50%"
            } else {
                this.$refs.elem.style.width = "100%"
            }
        },

        onChangeData(evt: ElemEvent<any>) {
            const value = this.form_value
            value[evt.name] = evt.value

            this.$emit("change-data", {
                value: value,
                type: "elem-form",
            })
        },

        getTypeName(type: string) {
            switch (type) {
                case "Select":
                    return "（选择）"
                case "Upload":
                    return "（上传文件）"
                case "Switch":
                    return "（开关）"
                default:
                    return ""
            }
        },

        getValue(field: string, name: string, idx: number, key?: string) {
            try {
                var value: any

                if (!name || name === "null") {
                    value = this.initial_value[field]
                } else if (this.initial_value[name] && !Utils.isBlank(idx)) {
                    value = this.initial_value[name][idx][field]
                } else {
                    value = this.initial_value[name][field]
                }

                if (key && Utils.isExist(value)) {
                    if (value instanceof Array) {
                        return Utils.each(value, v => v[key])
                    }

                    return value[key]
                }

                return value
            } catch (e) {
                return null
            }
        },

        getComponent(name: string): any {
            return require(`./${name}.vue`).default
        },

        getConditionValue() {
            var c: string = this.data.where

            if (!c) {
                this.isDisplay = true
                return true
            }
            
            var isDisplay = new Function(`return ${c.replace(/&{(\w*)}/g, "this?.$1")}`).call(this.form_value)

            if (!this.isDisplay && isDisplay) {
                this.$nextTick(() => this.onResize())
            }

            this.isDisplay = isDisplay

            return isDisplay
        },
    },
}
